import { getFilteredContacts } from 'modules/settings/workflow_automation/helpers/automationCommonHelpers';

/** --- Generting message senders list --- **/
export const getMessageSendersList = (messageRecipientsList = []) => {
  try {
    if (messageRecipientsList?.length > 0) {
      let allSendersArr = messageRecipientsList?.filter((recipient, idx) => recipient?.code !== 'Groups');

      //Deep copy of "element" is done to get exact filtered list for senders. Otherwise it will affect the original reference of the array inside this "element" object
      return allSendersArr?.map(({ ...element }, idx) => {
        if (element.code === 'Users') {
          element['items'] = element?.items.filter((entries, idx) => !['primary_contact', 'billing_contact']?.includes(entries?.value));
        }
        return element;
      });
    }

    //else return empty array
    return [];
  } catch (error) {
    console.log('error', error);
  }
};

/** --- Fetching message sender detail --- **/
export const getMessageSenderDetails = (params) => {
  const { messageRecipientsList, messageFrom } = params || {};
  let usersArr = messageRecipientsList?.filter((recipient, idx) => recipient?.code === 'Users');
  let userDetailObj = usersArr[0]?.items?.find((usr, idx) => usr?.value === messageFrom);
  return userDetailObj;
};

/** --- generateFullAttendeesList - function generates full "Attendees" list including Primary and Billing Contacts--- **/
export const generateFullMessageRecipientsList = (params = {}) => {
  const { firmUsersList = [], setMessageRecipientsList = () => {}, getAllRequiredContactsList = () => {} } = params || {};

  let allMessageRecipients = getAllRequiredContactsList(firmUsersList);
  setMessageRecipientsList(allMessageRecipients);
};

export const generateFullMessageRecipientsListReverse = (params = {}) => {
  const { firmUsersList = [], setMessageRecipientsList = () => {}, getAllRequiredContactsList = () => {} } = params || {};

  let allMessageRecipients = getAllRequiredContactsList(firmUsersList);
  setMessageRecipientsList(allMessageRecipients.reverse());
};

export const generateMessageRecipientsDetailsObjectArray = (params = {}) => {
  const { messageRecipientsList = [], messageToWatched: selectedMessageRecipients = [] } = params || {};

  let recipientDetailsArr = [];
  let allContactList = [];

  if (messageRecipientsList?.length > 0) {
    messageRecipientsList?.forEach((element) => {
      if (element?.items?.length) {
        allContactList.push(...element?.items);
      }
    });
  }

  if (selectedMessageRecipients?.length && allContactList?.length) {
    selectedMessageRecipients?.forEach((rec, idx) => {
      allContactList?.forEach((recipient, index) => {
        let condition = rec === recipient?.value;
        if (condition) {
          recipientDetailsArr.push(recipient);
        }
      });
    });
  }

  return recipientDetailsArr;
};

export const generatePayloadCompatibleFormattedMessageRecipientsList = (params) => {
  const { messageRecipientsArr = [], isBillingOrPrimary = false, isFirmUser = false, isUserGroup = false, isTeamMember } = params || {};

  let formatttedMessageRecipientsArr = [];

  let filteredMessageRecipientsArr = [];

  filteredMessageRecipientsArr = getFilteredContacts({
    arrayToBeFiltered: messageRecipientsArr,
    isBillingOrPrimary,
    isFirmUser,
    isUserGroup,
    isTeamMember,
  });

  formatttedMessageRecipientsArr = filteredMessageRecipientsArr?.map((recipient, idx) => {
    if (recipient?.email) {
      // Firm users only
      const { label: fullName, firm_user_id, contact_id, email, access_level, client_cognito_username } = recipient || {};

      return {
        // recipient_id: contact_id || firm_user_id || client_cognito_username,
        recipient_id: client_cognito_username ? client_cognito_username : contact_id || firm_user_id,
        recipient_name: fullName,
        cognito_username: client_cognito_username,
        client_cognito_username,
        firm_user_id,
        contact_id,
        email,
        access_level,
      };
    } else if (recipient?.group_id) {
      // User group items only
      const { label: groupName, sk, pk, group_id } = recipient || {};

      return {
        group_name: groupName,
        sk,
        group_id,
        pk,
      };
    } else if (recipient?.code && recipient?.code === 'TEAM_MEMBER_ROLE') {
      //Team member roles only
      return recipient?.value;
    }
    // primary and billing contacts only
    return recipient?.value;
  });

  return formatttedMessageRecipientsArr;
};
